import { DeleteOutlined, WarningOutlined } from '@ant-design/icons'
import ActivityLog from '@components/activityLog/ActivityLog'
import Page from '@components/Page/Page'
import { useAppSelector } from '@store/hooks'
import { selectSelectedEvent } from '@store/membership/EventReducer'
import { SBRM, SBRMAction } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import { Alert, Button, Col, Flex, Typography } from 'antd'

const { Text, Title } = Typography

const SettingsTab = () => {
  const event = useAppSelector(selectSelectedEvent())

  if (!event) {
    return <></>
  }

  return (
    <Page noWrapWithCol rowGutter={[32, 32]}>
      <Col span={10}>
        <Flex vertical gap={32}>
          <Flex vertical gap={8}>
            <Title level={5} className="m-0">
              <WarningOutlined /> Danger zone
            </Title>
            <Alert
              description={
                <Text>
                  <Text type="danger">
                    Deleting the event will also delete all associated
                    resources, participations...
                    <br />
                    This action is immediate and cannot be undone.
                    <br />
                    <br />
                    <Text type="danger" strong>
                      Warning: You cannot delete an event with participants.
                      <br />
                    </Text>
                  </Text>
                </Text>
              }
              action={
                <SBRM.Actions
                  entity={Entity.event}
                  entityId={event.id}
                  actions={[SBRMAction.Delete]}
                  disabled={event.fillRate != 0}
                  trigger={
                    <Button danger>
                      <DeleteOutlined /> Delete
                    </Button>
                  }
                />
              }
              type="error"
            />
          </Flex>
        </Flex>
      </Col>
      <Col span={14}>
        <ActivityLog.Timeline
          entity="event"
          entityId={event.id}
          cardProps={{
            style: { maxHeight: 500, overflow: 'scroll', padding: 10 },
          }}
        />
      </Col>
    </Page>
  )
}

export default SettingsTab
